export const errorMessages = {
  DIGIT_REQUIRED: 'Deve conter um digito maior que zero',
  INVALID_ZIP_CODE: 'CEP inválido',
  INVALID_ADDRESS: 'Endereço inválido',
  INVALID_CELLPHONE_FORMAT: 'Formato de celular inválido',
  INVALID_EMAIL: 'Email inválido',
  INVALID_NAME: 'Nome inválido',
  INVALID_PASSWORD: 'Senha incorreta',
  MIN_LENGTH_CHARACTERS: (min: number) => `Mínimo de ${min} caracteres`,
  PASSWORDS_DO_NOT_MATCH: 'As senhas estão diferentes',
  PHONE_NUMBERS_MATCHING:
    'Os telefones do titular e do contato de emergência devem ser diferentes.',
  REQUIRED_FIELD: 'Campo obrigatório',
  REQUIRED_OPTION: 'Selecione uma opção',
  REQUIRED_ZIP_CODE: 'CEP é obrigatório',
  SCREENING_STARTING_ERROR:
    'Ocorreu um erro ao iniciar a triagem, tente novamente.',
  SCREENING_DATA_RECOVER_ERROR:
    'Ocorreu um erro ao obter dados da triagem, tente novamente.',
  INVALID_DATE: 'Informe uma data correta',
  INVALID_CPF: 'CPF inválido',
  INVALID_BIRTH_DATE: 'Data de nascimento inválida',
  INVALID_PHONE: 'Telefone inválido',
  INVALID_ACCEPT_TERMS: 'Você deve aceitar os termos',
} as const
